import React from "react"
import { Box, Container } from "@theme-ui/components"

const VideoThumb = ({ video }) => {
  return (
    <Container sx={{ padding: "0!important" }}>
      <Box
        sx={{
          iframe: {
            width: ["100%", "560px"],
            height: ["100%", "415px", "315px"],
          },
        }}
        dangerouslySetInnerHTML={{ __html: video.embed }}
      />
    </Container>
  )
}

export default VideoThumb
